import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Spinner } from 'V2/Shared/Spinner';
import { Checkbox } from 'V2/Shared/Checkbox';
import { ErrorRetry } from 'V2/Shared/ErrorRetry';
import styles from '../styles.module.css';

interface UWBlobSectionProps {
  isLoading: boolean;
  error: string | null;
  content: string | null;
  isAccepting: boolean;
  acceptError: string | null;
  onAgree: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFetchRetry: () => void;
}

export const UWBlobSection: React.FC<UWBlobSectionProps> = ({
  isLoading,
  error,
  content,
  isAccepting,
  acceptError,
  onAgree,
  onFetchRetry,
}) => {
  return (
    <div className={styles.uwSection}>
      {isLoading && (
        <div className={styles.sectionLoader}>
          <Spinner variant="blue" />
        </div>
      )}
      {error && <ErrorRetry onRetry={onFetchRetry}>{error}</ErrorRetry>}
      {!isLoading && !error && content && (
        <>
          <div className={styles.markdownContent}>
            <ReactMarkdown skipHtml>{content}</ReactMarkdown>
          </div>
          <div className={styles.uwAgreement}>
            <Checkbox
              name="uw_consent"
              label="I have read and agree to the above statements."
              checked={isAccepting}
              onChange={onAgree}
            />
            {isAccepting && <Spinner variant="blue" />}
            {acceptError && <p className={styles.uwError}>{acceptError}</p>}
          </div>
        </>
      )}
    </div>
  );
};
